import AOS from 'aos';

AOS.init({
    once: true,
    offset: 100,
    startEvent: 'load',
});

AOS.refresh(true);
